const query = {}

/**
 * w （已经弃用，请使用R）过滤条件
 * r 过滤条件
 * o 排序
 * j 左连接、右连接 ON 后面过滤条件，主要面向后端开发人员
 * p 分页条件
 * s 过滤字段
 */
query.new = () => {
  return {
    'w': [],
    'r': [],
    'o': [],
    'j': [],
    'p': {},
    's': {}
  }
}

/**
 * 数组过滤条件
 * @param {query} q
 * @param {array} arrKv 数组：key/value
 * @param {array} arrKm 数组：key/mode
 */
query.toF = (q, arrKv, arrKm) => {
  for (var i in arrKv) {
    query.toR(q, i, arrKv[i], arrKm[i])
  }
  return q
}

/**
 * 过滤条件
 * @param {query} q
 * @param {key} k
 * @param {value} v
 * @param {mode} m 默认值（LK）非必填
 * @param {type} t1 默认值（and）非必填
 * @param {seq} s 默认值（0）非必填
 * @param {name} n 默认值（a1）非必填
 * @param {type} t 默认值（and）非必填
 */
query.toR = (q, k, v, m, t1, s, n, t) => {
  if (v === '') {
    return q
  }
  if (m === 'IS' || m === 'NIS') {
  } else {
    if (v === null) {
      return q
    }
  }
  if (typeof m === 'undefined') {
    m = 'LK'
  }
  if (typeof n === 'undefined') {
    n = 'a1'
  }
  if (typeof t === 'undefined') {
    t = 'and'
  }
  if (typeof t1 === 'undefined') {
    t1 = 'and'
  }
  if (typeof s === 'undefined') {
    s = 0
  }
  let rObj = null
  q.r.forEach(function (val, i) {
    if (val.n === n) {
      rObj = val
    }
  })
  if (rObj) {
    rObj.w.push({
      'k': k,
      'v': v,
      'm': m,
      't': t1,
      's': s
    })
  } else {
    q.r.push({
      'n': n,
      't': t,
      'w': [{
        'k': k,
        'v': v,
        'm': m,
        't': t1,
        's': s
      }]
    })
  }
  return q
}

/**
 * 过滤条件（已经弃用，请使用toR方法）
 * @param {query} q
 * @param {key} k
 * @param {value} v
 * @param {mode} m 默认值（LK）非必填
 * @param {type} t1 默认值（and）非必填
 * @param {seq} s 默认值（0）非必填
 */
query.toW = (q, k, v, m, t1, s) => {
  if (v === '') {
    return q
  }
  if (m === 'IS' || m === 'NIS') {
  } else {
    if (v === null) {
      return q
    }
  }
  if (typeof m === 'undefined') {
    m = 'LK'
  }
  if (typeof t1 === 'undefined') {
    t1 = 'and'
  }
  if (typeof s === 'undefined') {
    s = 0
  }
  q.w.push({
    'k': k,
    'v': v,
    'm': m,
    't': t1,
    's': s
  })
  return q
}

/**
 * 过滤条件（已经弃用，请使用toR方法）
 * @param {query} q
 * @param {key} k
 */
query.toWNull = (q, k) => {
  q.w.push({
    'k': k,
    'v': null,
    'm': 'IS'
  })
  return q
}

/**
 * 左连接、右连接 ON 后面过滤条件
 * @param {query} q
 * @param {key} k
 * @param {value} v
 * @param {mode} m 默认值（LK）非必填
 * @param {name} n 设置联表查询时，ON的参数名
 * @param {type} t1 默认值（and）非必填
 * @param {seq} s 默认值（0）非必填
 */
query.toJ = (q, k, v, m, n, t1, s) => {
  if (v === null || v === '') {
    return q
  }
  if (typeof m === 'undefined') {
    m = 'LK'
  }
  if (typeof t1 === 'undefined') {
    t1 = 'and'
  }
  if (typeof s === 'undefined') {
    s = 0
  }
  let rObj = null
  q.j.forEach(function (val, i) {
    if (val.n === n) {
      rObj = val
    }
  })
  console.log(rObj)
  if (rObj) {
    rObj.r[0].w.push({
      'k': k,
      'v': v,
      'm': m,
      't': t1,
      's': s
    })
  } else {
    q.j.push({
      'n': n,
      'r': [{
        't': 'and',
        'w': [{
          'k': k,
          'v': v,
          'm': m,
          't': t1,
          's': s
        }]
      }]
    })
  }
  return q
}

/**
 * 排序
 * @param {query} q
 * @param {key} k 排序字段
 * @param {type} t 升序还是降序 asc or desc
 */
query.toO = (q, k, t) => {
  if (typeof k === 'undefined' || k === '') {
    return q
  }
  if (typeof t === 'undefined') {
    t = 'desc'
  }
  q.o.push({
    'k': k,
    't': t
  })
  return q
}

/**
 * 分页条件
 * @param {query} q
 * @param {pageNo} n 第几页
 * @param {pageSize} s 每页条数
 * @param {count} c 是否查询总数，非必填，如果设置为1，则不会查询总数
 */
query.toP = (q, n, s, c) => {
  if (typeof c === 'undefined' || c === '') {
    c = 0
  }
  q.p = {
    'n': n,
    's': s,
    'c': c
  }
  return q
}

/**
 * 过滤字段
 * @param {query} q
 * @param {value} v 过滤字段，支持String类型多个字段(",")逗号隔开，如："username,mob"，或者进行数组赋值，如：["username", "mob"]
 */
query.toS = (q, v) => {
  q.s = {
    'v': v
  }
  return q
}

/**
 * query对象转string
 */
query.toJsonStr = (q) => {
  return JSON.stringify(q)
}

/**
 * 查询条件url编码
 */
query.toEncode = (q) => {
  return encodeURIComponent(JSON.stringify(q))
}

/**
 * 查询条件频接
 */
query.toQ = (q) => {
  return '?query=' + encodeURIComponent(JSON.stringify(q))
}

export default query
